import { ViewModel,View, ObservableArray } from "binder"
import  { HomePageView } from "./homePage-view"
import { WindowViewModel } from "../userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { AccessibleFormViewModel, CreateWindowMessage } from "../userMainWindow/userMainWindow-viewModel";
import { stringIsNullOrEmpty } from "../utilities";

export class HomePageViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'HOME PAGE';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.backgroundColors = new Map<string,string>();
        (<any>window).openHomePageTile = this.open.bind(this);
        this.tiles = ObservableArray.create<singleItem>();
        this.loadData()
    }
    GetDefaultView(): View <ViewModel> {
        return new HomePageView();
    }
    public getTypeId(): string {
        return "VM-3410B0C2-8EDE-4F76-A04A-1CA27A01FE12"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set tiles(v: ObservableArray<singleItem>) { this._tiles = v; } public get tiles(): ObservableArray<singleItem> { return this._tiles;} private _tiles: ObservableArray<singleItem>;
    public set self(v: HomePageViewModel) { this._self = v; } public get self(): HomePageViewModel { return this._self;} private _self: HomePageViewModel;
    public set backgroundColors(v: Map<string,string>) { this._backgroundColors = v; } public get backgroundColors(): Map<string,string> { return this._backgroundColors;} private _backgroundColors: Map<string,string>;
    
    itemRemoved(form: AccessibleFormViewModel) {
        let relatedForm = this.tiles.filter(x=>x.id == form.formId).at(0);
        if(relatedForm){
            this.tiles.remove(relatedForm);
        }
    }
    itemAdded(form: AccessibleFormViewModel) {
        let item = new singleItem(this);
        item.id = form.formId;
        item.path = form.formName;
        item.name = item.path.split("/").at(-1);
        item.processFormId = form.processFormId;
        item.processFormName = form.processFormName;
        item.iconClass = form.icon;
        this.tiles.push(item)
    }
    
    public tryRedraw(){
        
    }
    private async loadData(){
        try {
            this.isLoading = true;
            let accessibleFormsPromise = ServerConnection.callServer('Complex/AuthorizationServices/GetAccessibleFormsForCurrentUser', {})
            let homePageStructurePromise = ServerConnection.callServer('Complex/SecurityRawDataServices/LoadHomePageStructure', {})
            let [accessibles,homePageStructureResult] = await Promise.all([accessibleFormsPromise,homePageStructurePromise]);
            let homePageStructure = [];
            if(stringIsNullOrEmpty(homePageStructureResult.HomePageStructure)==false){
                homePageStructure =JSON.parse(homePageStructureResult.HomePageStructure);
            }
            this.tiles.update(...accessibles.Forms.filter(x=>x.IsFavorite).map(x=>{
                let item = new singleItem(this);
                item.id = x.Id;
                item.path = x.Name;
                item.name = item.path.split("/").at(-1);
                item.processFormId = x.ProcessFormId;
                item.processFormName = x.ProcessFormName;
                item.iconClass = x.Icon
                let relatedHomePageStructure = homePageStructure.filter(x=>x.id==item.id).at(0);
                if(relatedHomePageStructure){
                    item.x = relatedHomePageStructure.x;
                    item.y = relatedHomePageStructure.y;
                    item.width = relatedHomePageStructure.w;
                    item.height = relatedHomePageStructure.h;
                    item.backgroundColor = relatedHomePageStructure.backgroundColor;
                    if(relatedHomePageStructure.backgroundColor){
                        this.backgroundColors.set(item.id,relatedHomePageStructure.backgroundColor)
                    }
                }
                return item;
            }));
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    saveChanges(arg0: { x: number; y: number; w: number; h: number; id: string; }[]) {
        try {
            arg0.forEach(e => {
                let r = this.tiles.filter(x=>x.id==e.id).at(0);
                if(r!=null){
                    r.x = e.x;
                    r.y = e.y;
                    r.width = e.w;
                    r.height = e.h;
                    if(this.backgroundColors.has(e.id)){
                        r.backgroundColor = (<any>e).backgroundColor;
                
                    }
                }
            });
            ServerConnection.callServer('Complex/SecurityRawDataServices/UpdateHomePageStructure', {
                HomePageStructure : JSON.stringify(arg0)
            });
        } catch (ex) {
            console.log(ex);
        } finally {
        }
    }

    open(id:string){
        
        let form = this.tiles.filter(x=>x.id==id).at(0);
        if(form){
            if(stringIsNullOrEmpty(form.processFormId)==false){
                let message = new CreateWindowMessage('5ec1473c-34a7-467a-9ec4-b039fa416a8c');
                message.isProcessForm = true;
                message.processFormId = form.processFormId;
                message.processFormName = form.name.split('/').at(-1);
                this.handleMessage(message);
            }else{
                let message = new CreateWindowMessage(form.id);
                this.handleMessage(message);
    
            }
    
        }
    }
    
}

export class singleItem extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set path(v: string) { this._path = v; } public get path(): string { return this._path;} private _path: string;
    public set iconClass(v: string) { this._iconClass = v; } public get iconClass(): string { return this._iconClass;} private _iconClass: string;
    public set processFormName(v: string) { this._processFormName = v; } public get processFormName(): string { return this._processFormName;} private _processFormName: string;
    public set processFormId(v: string) { this._processFormId = v; } public get processFormId(): string { return this._processFormId;} private _processFormId: string;
    
    public set width(v: number) { this._width = v; } public get width(): number { return this._width;} private _width: number;
    public set height(v: number) { this._height = v; } public get height(): number { return this._height;} private _height: number;
    public set x(v: number) { this._x = v; } public get x(): number { return this._x;} private _x: number;
    public set y(v: number) { this._y = v; } public get y(): number { return this._y;} private _y: number;
    public set backgroundColor(v: string) { this._backgroundColor = v; } public get backgroundColor(): string { return this._backgroundColor;} private _backgroundColor: string;
     
    onChoose(){

    }
}
